import 'regenerator-runtime/runtime';
import { GraphiQL } from './components/GraphiQL';
export { GraphiQL };
export default GraphiQL;
//# sourceMappingURL=index.js.map